import { render, staticRenderFns } from "./ProductionInit.vue?vue&type=template&id=5d56889c&scoped=true"
import script from "./ProductionInit.vue?vue&type=script&lang=js"
export * from "./ProductionInit.vue?vue&type=script&lang=js"
import style0 from "./ProductionInit.vue?vue&type=style&index=0&id=5d56889c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56889c",
  null
  
)

export default component.exports